// extracted by mini-css-extract-plugin
export default {"ourTeam":"TeamSlide_ourTeam__-aVoi"};